import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10.0001 10.8346C10.4603 10.8346 10.8334 10.4615 10.8334 10.0013C10.8334 9.54106 10.4603 9.16797 10.0001 9.16797C9.53984 9.16797 9.16675 9.54106 9.16675 10.0013C9.16675 10.4615 9.53984 10.8346 10.0001 10.8346Z" fill="#374151" stroke="#9CA3AF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.0001 4.9987C10.4603 4.9987 10.8334 4.6256 10.8334 4.16536C10.8334 3.70513 10.4603 3.33203 10.0001 3.33203C9.53984 3.33203 9.16675 3.70513 9.16675 4.16536C9.16675 4.6256 9.53984 4.9987 10.0001 4.9987Z" fill="#374151" stroke="#9CA3AF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.0001 16.6667C10.4603 16.6667 10.8334 16.2936 10.8334 15.8333C10.8334 15.3731 10.4603 15 10.0001 15C9.53984 15 9.16675 15.3731 9.16675 15.8333C9.16675 16.2936 9.53984 16.6667 10.0001 16.6667Z" fill="#374151" stroke="#9CA3AF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);


export default Icon;
